import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_USER_BOOKMARKS: undefined,
    API: {
      GET_USER_BOOKMARKS: apiResourceActionCreator('bookmarks'),
    }
  }
});

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.Bookmarks), authToken, actions.user.api.getUserBookmarks);

export function* getUserBookmarks() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
};

const configuration = {
  name: 'getUserBookmarks',
  action: actions,
  sagas: getUserBookmarks,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingBookmark: true
    }),
    success: (state, action) => ({
      ...state,
      currentUserBookmarks: action.payload.bookmarks,
      isFetchingBookmark: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingBookmark: false
    }),
  }
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getUserBookmarks.js